import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import React from "react";
import { action } from 'mobx';
import applicationContext from 'core/utils/applicationContext';
import {ContactDepartmentService} from 'application/contact-department/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import _ from 'lodash';

@applicationContext
class ContactDepartmentListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const contactDepartmentService = new ContactDepartmentService(rootStore.application.baasic.apiClient);
        const permissions = rootStore.userStore.user.permissions;
        let actions = {};
        let routes = {};

        if(permissions.importReferenceSection !== undefined && permissions.importReferenceSection.includes("Full")){
            actions = {
                onDelete: (item) => this.deleteResource(item),
                onEdit: async (item) => routes.edit(item),
                actionsWidth: 80
            };
            routes = {
                create: () => rootStore.routerStore.goTo(
                    'master.app.main.contact-department.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => i.id === item.id,() => item.name);
                    return rootStore.routerStore.goTo(
                        'master.app.main.contact-department.edit',
                        { id: item.id }
                    )
                },
            };
        }

        super(rootStore, {
            name: 'contact-department',
            autoInit: true,
            routes: routes,
            actions: () => {
                return {
                    find: async (params) => {
                        params.embed = 'ContactDepartmentType'
                        const response = await contactDepartmentService.find({
                            ...params,
                        });
                       
                        const responseData = _.extend(response.data, {
                            item: _.map(response.data.item, (item => {
                                return _.extend(
                                    item, {
                                     contactDepartmentType: item.contactDepartmentType && item.contactDepartmentType.name ? item.contactDepartmentType.name : '' 
                                    }
                                );
                            }))
                        });            
                        return responseData;
                    },
                    delete: async (item) => {
                        await contactDepartmentService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'CONTACT_DEPARTMENT.LIST.COLUMNS.NAME',
                },  
                {
                    key: 'contactDepartmentType',
                    title: 'CONTACT_DEPARTMENT.LIST.COLUMNS.TYPE',
                },  
                {
                    key: 'overviewRecipientType',
                    title: 'CONTACT_DEPARTMENT.LIST.COLUMNS.OVERVIEW',
                    sortable: false,
                    cell: (cellProps) => {
                        const value = cellProps.dataItem[cellProps.field];
                        return (
                            <td>
                                <div className="type--center">
                                    {value === '' || value == null ?        
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                    : <span>{value}</span>}
                                </div>
                            </td>
                        );
                    },
                    width: 100,
                    headerClassName: "center"
                },
                {
                    key: 'docRequestRecipientType',
                    title: 'CONTACT_DEPARTMENT.LIST.COLUMNS.DOC_REQUEST',
                    sortable: false,
                    cell: (cellProps) => {
                        const value = cellProps.dataItem[cellProps.field];
                        return (
                            <td>
                                <div className="type--center">
                                    {value === '' || value == null ?        
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                    : <span>{value}</span>}
                                </div>
                            </td>
                        );
                    },
                    width: 100,
                    headerClassName: "center"
                },
                {
                    key: 'inventoryRecipientType',
                    title: 'CONTACT_DEPARTMENT.LIST.COLUMNS.INVENTORY',
                    sortable: false,
                    cell: (cellProps) => {
                        const value = cellProps.dataItem[cellProps.field];
                        return (
                            <td>
                                <div className="type--center">
                                    {value === '' || value == null ?        
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                    : <span>{value}</span>}
                                </div>
                            </td>
                        );
                    },
                    width: 100,
                    headerClassName: "center"
                },
                {
                    key: 'pickTicketRecipientType',
                    title: 'Packing List',
                    sortable: false,
                    cell: (cellProps) => {
                        const value = cellProps.dataItem[cellProps.field];
                        return (
                            <td>
                                <div className="type--center">
                                    {value === '' || value == null ?        
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                    : <span>{value}</span>}
                                </div>
                            </td>
                        );
                    },
                    width: 100,
                    headerClassName: "center"
                },
                {
                    key: 'deliveryTicketType',
                    title: 'Delivery Ticket',
                    sortable: false,
                    cell: (cellProps) => {
                        const value = cellProps.dataItem[cellProps.field];
                        return (
                            <td>
                                <div className="type--center">
                                    {value === '' || value == null ?        
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                    : <span>{value}</span>}
                                </div>
                            </td>
                        );
                    },
                    width: 100,
                    headerClassName: "center"
                },
            ]),
            actions: actions
        }));
    } 

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('CONTACT_DEPARTMENT.LIST.ACTIONS.SUCCESS_DELETE');
    }

    @action.bound
    notifyErrorDelete(err) {
        this.rootStore.notificationStore.error(err.data);
    }

}

export default ContactDepartmentListViewStore;